<template>
  <section class="content">
	<div class="row">
      <div class="col-md-4" v-if="hasPermission('usuario.read')">
        <div class="info-box">
          <span class="info-box-icon bg-green">
            <i class="fa fa-check"></i>
          </span>
          <div class="info-box-content">
            <h4 class="font-weight-bold">Atendimentos Marcados</h4>

            <span class="info-box-text">{{ total_marcacao }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="hasPermission('usuario.read')">
        <div class="info-box">
          <span class="info-box-icon bg-yellow">
            <i class="fa fa-exchange"></i>
          </span>
          <div class="info-box-content">
            <h4 class="font-weight-bold">Atendimentos Regulados</h4>

            <span class="info-box-text">{{ total_regulacao }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="hasPermission('usuario.read')">
        <div class="info-box">
          <span class="info-box-icon bg-red">
            <i class="fa fa-close"></i>
          </span>
          <div class="info-box-content">
            <h4 class="font-weight-bold">Atendimentos Negativados</h4>

            <span class="info-box-text">{{ total_negativado }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
		<h4>COMUNICADOS IMPORTANTES</h4>

		<template  v-for="(comunicado, index) in comunicados.data">
			<div class="box box-success" :key="index" v-if="comunicado[`${$store.state.user.nivel}_visualiza`]">
				<div class="box-header with-border">
					<h3 class="box-title">
					<b>{{ comunicado.data_inicial | dataFormatada }} - {{ comunicado.titulo }}</b>
					</h3>
				</div>

				<div class="box-body" v-html="comunicado.descricao"></div>
			</div>
		</template>
		<div v-if="comunicados.data.length == 0">
			Nenhum comunicado vigente.
		</div>
      </div>
	  <div v-if="visualizaArquivo" class="col-md-6">
		<h4>DOCUMENTOS COMPARTILHADOS</h4>

        <div class="box box-warning">
          <div class="box-body">
			<p>
            <strong>10/12/2020</strong>  - <a href="/static/docs/profissionais-cemae.pdf" download>Relação de profissionais do CEMAE no mês de Novembro 2020 (3ª fase de reabertura)</a>
			</p>
			<p>
			<strong>04/10/2019</strong>  - <a href="/static/docs/circular6.pdf" download>OFÍCIO CIRCULAR Nº. 006/2019-GAB/SMS</a>
			</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
export default {
  data: () => ({
    total_marcacao: 0,
    total_regulacao: 0,
    total_negativado: 0,
    visualizaArquivo: true,
	comunicados: []
  }),
  mounted() {
    this.$nextTick(() => {
		this.getComunicados();
    });
  },
  methods: {
	getComunicados() {
		let config = this.$store.getters.getHeaderAuth;
		axios
			.get(`${this.$store.state.serverURI}/api/administracao/comunicados`, config)
			.then(response => {
				this.comunicados = response.data;
			})
			.catch(error => {
				this.$store.commit("throwException", error);
			});
	},
  }
};
</script>
<style scoped>
	.data-comunicado {
		font-size: 20px;
		font-weight: bold;
	}
	.box-body {
		font-size: 16px !important;
	}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?4ac41c79